import React from "react";

export default function TermsOfService() {
  return (
    <div className="about-container">
      <div className="max-w-4xl mx-auto bg-white shadow-md rounded-2xl p-8 sm:p-12">
        <header className="mb-6">
          <h1 className="text-2xl sm:text-3xl font-semibold">Terms of Service</h1>
          <p className="mt-1 text-sm text-gray-600">Effective Date: October 1, 2025</p>
        </header>

        <article className="prose prose-sm sm:prose lg:prose-lg">
          <section>
            <h2>Welcome</h2>
            <p>
              Welcome to <strong>jsonconverter.org</strong> ("we", "our", "us"). By accessing or using our website and
              services, you agree to these Terms of Service ("Terms"). Please read them carefully before using our site.
            </p>
          </section>

          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>
              By using jsonconverter.org, you agree to comply with and be bound by these Terms. If you do not agree,
              please do not use our website.
            </p>
          </section>

          <section>
            <h2>2. Our Services</h2>
            <p>
              jsonconverter.org provides free online tools for formatting and converting JSON, XML, YAML, CSV, and
              programming language code snippets. Our tools are provided <em>as-is</em> for convenience. We do not
              guarantee 100% accuracy of all conversions. You are responsible for verifying outputs before using them in
              production.
            </p>
          </section>

          <section>
            <h2>3. Google Ads & Third-Party Advertising</h2>
            <p>
              We may display advertisements on the Site, including ads served by Google ("Google Ads"). These ads may use
              cookies and other tracking technologies to deliver and personalize advertising. We do not control the data
              collection or use by third-party advertising networks. Please review the privacy practices of advertisers
              before interacting with ads.
            </p>
            <p>
              For information about how Google collects and uses data when you use our site, please review Google's
              <a
                href="https://policies.google.com/technologies/ads"
                target="_blank"
                rel="noopener noreferrer"
                className="ml-1 text-blue-600 hover:underline"
              >
                Advertising & Privacy information
              </a>
              .
            </p>
            <p>
              If you want to learn more about Google’s general privacy policy, visit
              <a
                href="https://policies.google.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className="ml-1 text-blue-600 hover:underline"
              >
                Google Privacy Policy
              </a>
              .
            </p>
          </section>

          <section>
            <h2>4. User Responsibilities</h2>
            <p>When using our site, you agree that you will not:</p>
            <ul>
              <li>Upload or input any illegal, harmful, or malicious code.</li>
              <li>Use the site in a way that could damage, disable, or overload our servers.</li>
              <li>Attempt to reverse-engineer or misuse our tools.</li>
            </ul>
          </section>

          <section>
            <h2>5. Intellectual Property</h2>
            <p>
              All site content, branding, and design belong to jsonconverter.org. You retain all rights to the data/code
              you input into our tools. We do <strong>not</strong> store, share, or claim ownership of your data (see our
              Privacy Policy for details).
            </p>
          </section>

          <section>
            <h2>6. Disclaimer of Warranties</h2>
            <p>
              The website is provided on an <em>“as is” and “as available”</em> basis. We make no warranties regarding
              accuracy, reliability, or availability. Use of the site is at your own risk.
            </p>
          </section>

          <section>
            <h2>7. Limitation of Liability</h2>
            <p>
              We are not liable for any damages, losses, or issues resulting from use of our tools. This includes data
              loss, incorrect code conversions, or third-party actions.
            </p>
          </section>

          <section>
            <h2>8. Third-Party Links</h2>
            <p>
              Our site may contain links to third-party websites. We are not responsible for their content, policies, or
              practices. Links to advertisers or third parties do not imply endorsement.
            </p>
          </section>

          <section>
            <h2>9. Changes to Terms</h2>
            <p>
              We may update these Terms at any time. Updates will be posted on this page with a revised "Effective
              Date." Continued use of our site means you accept the updated Terms.
            </p>
          </section>

          <section>
            <h2>10. Governing Law</h2>
            <p>
              These Terms are governed by and construed under the laws of India. Any disputes shall be subject to the
              jurisdiction of courts located in India.
            </p>
          </section>

          <section>
            <h2>11. Contact Us</h2>
            <p>
              If you have questions about these Terms, you can reach us at: <br />
             {/* <a href="mailto:support@jsonconverter.org" className="text-blue-600 hover:underline">support@jsonconverter.org</a>
			 */}
            </p>
          </section>

          <footer className="mt-6 text-sm text-gray-600">
            <p>
              <strong>Note:</strong> This template is provided for convenience and does not constitute legal advice. If you
              need a legally binding agreement, consult a qualified attorney.
            </p>
          </footer>
        </article>
      </div>
    </div>
  );
}
